import { useAuth0 } from '@auth0/auth0-react';
import './style.css'
import { PageLoader } from './util/PageLoader';
import { ErrorPage } from './error/ErrorPage';
import { HomePage } from './homepage/HomePage';
import { NewUserPage } from './error/NewUserPage';

export const Home = () => {
    const {
        isAuthenticated,
        user,
        isLoading,
        error
    } = useAuth0();

    const checkRoles = (dinneyRoles : String[]) : boolean => {
        if (dinneyRoles === undefined || dinneyRoles.length === 0) {
           return false
        } else if (dinneyRoles.includes(process.env.REACT_APP_DINNEY_ROLE!)) {
           return true
        } else if (dinneyRoles.includes(process.env.REACT_APP_DINNEY_ROLE_PARENT!)) {
            return true
        }

        return false
    }

    if (isLoading) {
        return (
            <PageLoader />
        )
    }

    if (error?.message !== undefined) {
        return (
            <ErrorPage />
        )
    }

    if (isAuthenticated && !checkRoles(user?.dinneyroles)
        && !user?.email_verified) {
        return (<NewUserPage />)
    } 


    return (
        <div className={'bgrnd'}>
            <HomePage />
        </div>

    );    
    
    
}
